<template>
  <v-app>
    <v-navigation-drawer
      app
      color="tertiary"
      v-model="drawer"
      v-if="isAuth"
      data-intro="Главное меню"
      :width="220"
    >
      <v-list-item class="drawer-title">
        <v-list-item-avatar>
          <v-img src="@/assets/logo.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title"> E-заказ </v-list-item-title>
          <v-list-item-subtitle> interfarmax </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <appMenu />

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="primary" v-if="isAuth" @click="signout()"
            >Выйти</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app dark color="primary">
      <v-app-bar-nav-icon
        aria-label="Переключить"
        v-if="isAuth"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span>E-Заказ</span>
        <span class="font-weight-light">&nbsp;Interfarmax</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon v-if="isAuth">{{ icons.accountCircleOutline }}</v-icon>
      <span class="px-1" v-if="isAuth">{{ this.user.login }}</span>
      <!-- <v-btn text v-if="isAuth" @click="signout()">Выйти</v-btn> -->
    </v-app-bar>

    <v-main sticky-container>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app dark color="primary">
      <div>
        <span v-if="isAuth"
          >{{ this.user.organizationName }}, {{ this.user.firstName }}
          {{ this.user.lastName }}</span
        >
      </div>
      <v-spacer></v-spacer>
      <div>
        <span>&copy; 2008-{{ new Date().getFullYear() }}</span>
        <span>&nbsp; Interfarmax</span>
      </div>
    </v-footer>

    <v-snackbar v-model="snackbar" top color="error" :timeout="snackbarTimeout">
      Ошибка: {{ this.error }}
      <v-btn dark text icon @click="snackbar = false">
        <v-icon>{{ icons.close }}</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

import appMenu from "@/components/App/Menu";

export default {
  name: "App",
  components: {
    appMenu,
  },
  computed: {
    ...mapState("users", {
      user: "user",
    }),
    ...mapState("logs", {
      isError: "isError",
      error: "errorMsg",
    }),
    isAuth() {
      return Object.keys(this.user).length > 0;
    },
  },
  methods: {
    ...mapActions({
      getUser: "users/GET_USER",
      logout: "users/LOGOUT",
    }),
    init() {
      this.getUser(this.user.userId);

      this.$store.subscribe((mutation) => {
        switch (mutation.type) {
          case "logs/SET_ERROR_OBJECT":
            this.snackbar = true;
            break;
        }
      });
    },
    signout: function () {
      this.logout();
      this.$router.push("/login");
    },
  },
  data: () => ({
    drawer: null,
    snackbar: false,
    snackbarTimeout: -1,
    icons: {
      accountCircleOutline: Icon.accountCircleOutline,
      close: Icon.close,
    },
  }),
  mounted() {
    this.init();
    // this.$intro().start();
  },
};
</script>
